import {Routes} from '@angular/router';
import {Login} from '@components/authentication/login/login';
import {Register} from '@components/authentication/register/register';
import {ResetPassword} from '@components/authentication/reset-password/reset-password';
import {VerifyEmail} from '@components/authentication/verify-email/verify-email';
// import {Pricing} from '@components/pricing/pricing';
import {ATTESTIO_DASHBOARD_ROUTE} from '@components/dashboard/dashboard.routes';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: Login },
  { path: 'register', component: Register},
  { path: 'reset-password', component: ResetPassword},
  { path: 'verify-email', component: VerifyEmail},
  // { path: 'pricing', component: Pricing },

  // TODO add protected routes
  { path: 'dashboard', children: ATTESTIO_DASHBOARD_ROUTE }
];
